<!-- 确认结算 -->
<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box">
            <div class="page-title text-center">确认结算</div>
            <div class="page-caption">
                <div class="cell">
                    <div class="cell__label">项目名称：</div>
                    <div class="cell__value">{{info.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">服务人员：</div>
                    <div class="cell__value">{{info.member.name}}</div>
                </div>
                <div class="cell">
                    <div class="cell__label">预计完成时间：</div>
                    <div class="cell__value">{{info.complete_time}}</div>
                </div>
            </div>
            <div class="page-content">
                <div class="caption">
                    <div class="cell">服务内容</div>
                    <div class="cell">单位</div>
                    <div class="cell">服务要求</div>
                    <div class="cell">确认数量</div>
                    <div class="cell">奖励金额</div>
                    <div class="cell">确认单价</div>
                    <div class="cell">服务合计</div>
                </div>
                <div class="box" v-for="(item, index) in info.settlement.listData" :key="index">
                    <div class="cell">
                        <el-tooltip :content="item.name">
                            <div class="content-ellipsis">{{item.name}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.unit}}</div>
                    <div class="cell">
                        <el-tooltip :content="item.demand">
                            <div class="content-ellipsis">{{item.demand}}</div>
                        </el-tooltip>
                    </div>
                    <div class="cell">{{item.amount}}</div>
                    <div class="cell">
                        {{item.award}}
                    </div>
                    <div class="cell">{{item.price}}</div>
                    <div class="cell">{{item.money}}</div>
                </div>
                <div class="box no-top-border">
                    <div class="cell">服务总计</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.settlement.total}}</div>
                </div>
                <div class="box">
                    <div class="cell">平台综合服务费</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.settlement.total_fee}}</div>
                </div>
                <div class="box">
                    <div class="cell">应支付平台金额</div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell"></div>
                    <div class="cell">{{info.settlement.pay_money}}</div>
                </div>
            </div>
            <div class="page-footer">
                <div class="handler-wraper">
                    <el-button type="default" style="margin-right: 20px;"
                               @click="goPage(`/index/project/detail?id=${$route.query.id}&panel=1`)">返回
                    </el-button>
                    <el-button type="primary" @click="onCommit($route.query.id, $route.query.sub_id)">确认结算</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router'
export default {
    name: 'QuerySettle',
    inject: ['goPage'],
    data () {
        return {
            info: {
                member: {},
                service: [],
                settlement: {
                    listData: []
                }
            }
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id, this.$route.query.sub_id)
    },
    methods: {
        getInfo (id, sub_id) {
            this.$http.get('/api/user/project/subinfo', {
                params: {
                    id,
                    sub_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.info = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        onCommit (id, sub_id) {
            this.$http.get('/api/user/project/subsettlement', {
                params: {
                    id,
                    sub_id
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: '结算成功'
                        })
                        router.push(`/index/project/serviceinfo?id=${this.info.id}&sub_id=${this.info.sub_id}`)
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";

    .page-title {
        padding-top: 43px;
        font-size: 20px;
        font-weight: bold;
    }

    .page-caption {
        display: flex;
        margin-top: 25px;
        margin-bottom: 15px;
        padding: 0 20px;

        .cell {
            flex: 1;
            display: flex;

            &:nth-child(2) {
                justify-content: center;
            }

            &:last-child {
                justify-content: flex-end;
            }
        }
    }

    .page-content {
        padding: 0 20px;

        .caption {
            display: flex;
            background-color: #F5F5FA;
            color: #909399;
            border-bottom: 1px solid $--border-color-base;
            border-top: 1px solid $--border-color-base;
        }

        .box {
            display: flex;
            border-bottom: 1px solid $--border-color-base;
        }

        .cell {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 48px;
            padding-left: 10px;
            display: flex;
            align-items: center;

            &:nth-child(1) {
                width: 150px;
            }

            &:nth-child(2) {
                width: 100px;
            }

            &:nth-child(3) {
                flex: 1;
            }

            &:nth-child(4) {
                width: 100px;
            }

            &:nth-child(5) {
                width: 150px;
            }

            &:nth-child(6) {
                width: 150px;
            }

            &:nth-child(7) {
                width: 100px;
            }
        }
    }

    .page-footer {
        .handler-wraper {
            width: 322px;
            margin: 138px auto 0;

            button {
                width: 144px;
            }
        }
    }
</style>
